import { isFunction } from "lodash-es";
export function toUnit(unit = "px") {
    return (value) => value + unit;
}
const withPx = toUnit();
export function toPx(arg) {
    return isFunction(arg)
        ? (designSystem) => {
            return withPx(arg(designSystem));
        }
        : withPx(arg);
}
